import { render, staticRenderFns } from "./SelectWithAutocomplete.vue?vue&type=template&id=3bd588f4"
import script from "./SelectWithAutocomplete.vue?vue&type=script&lang=js"
export * from "./SelectWithAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./SelectWithAutocomplete.vue?vue&type=style&index=0&id=3bd588f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports